import PuckEditor from "./Editor/PuckEditor";
import AnimationFadeIn from "@components/AnimationFadeIn";
import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFetchTable, useFetchTableWrapper } from "@hooks/useFetchDataTable";
import BackgroundImage from "@components/BackgroundImageCst";
import Table from "@components/Table";
import HeroCst from "@components/HeroCst";
import Breadcrumb from "@components/Breadcrumb";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { ActionsType } from "src/interfaces/Common";
import { MethodType } from "src/services/type";
import { fetcher } from "src/services/config";
import useSWRMutation from "swr/mutation";
import { useNavigate, useParams } from "react-router-dom";
import CustomRowAction from "@components/Table/components/CustomRowAction";
import { disableRowBasedOnDisableIf } from "@utils/utilsTable";
import { useAuth } from "@context/auth";
import { useFilters } from "@context/filters";
import { Initiative as InitiativeInterface } from "src/interfaces/Initiative";
import { EditorialResponse } from "./interfaces";
import useSWR from "swr";

const columns = [
  {
    accessorKey: "id",
    hasFilter: true,
    header: "ID",
    type: "autoIncrement",
  },
  {
    accessorKey: "corporate",
    hasFilter: true,
    header: "CORPORATE",
    type: "text",
  },
  {
    accessorKey: "nome_redazionale",
    hasFilter: true,
    header: "REDAZIONALE",
    type: "text",
  },
];

const dataTable = {
  metadata: {
    total_elements: 1,
    total_pages: 1,
  },
  output: [
    {
      id: 1,
      corporate: "digited",
      nome_redazionale: "swing",
    },
  ],
};

const Editorial = () => {
  const [dataPuck, setDataPuck] = useState<any>(null);
  const [configPuck, setConfigPuck] = useState<any>(null);
  const { t } = useTranslation(["certificates-page"]);

  const { idInitiative } = useParams();
  console.log("chiamata per redazionali di iniziativa: " + idInitiative);

  const navigate = useNavigate();
  const { user } = useAuth();
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${PagesID["corporate.initiative.editorial"]}`;
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    child?: ReactNode;
    message: string;
    description?: string;
  }>();
  const [editorialIdToDelete, setEditorialIdToDelete] = useState<string>();
  const { columns, dataTable, actionsTopToolbar, actionForRow, mutate } =
    useFetchTable(
      ServicesURL.editorial + `/initiatives/${idInitiative}`,
      PagesID["corporate.initiative.editorial"],
      filters[filterId],
    );

  const actionsRow: ActionsType[] = React.useMemo(() => {
    return actionForRow?.map((action: any) => {
      switch (action.type) {
        case "edit": {
          return {
            ...action,
            callBack: (editorial: any) => navigate(`${editorial.id}/edit`),
          };
        }
        case "delete": {
          return {
            ...action,
            callBack: (editorial: any) => setEditorialIdToDelete(editorial),
          };
        }
        default:
          return action;
      }
    });
  }, [actionForRow]);

  const { trigger: triggerDelete } = useSWRMutation(
    ServicesURL.editorial + `/${editorialIdToDelete}`,
    (url, params) => {
      return fetcher<any>(`${url}`, MethodType.DELETE);
    },
  );

  //DELETE EDITORIAL
  const handleDelete = React.useCallback(async () => {
    if (editorialIdToDelete) {
      setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
      try {
        await triggerDelete();
        setOpenToast({ s: StatusEnum.OK, message: "" });
      } catch (error) {
        setEditorialIdToDelete(undefined);
        setOpenToast(undefined);
        console.error("Error", error);
      }
      mutate && mutate();
    }
  }, [editorialIdToDelete, mutate, triggerDelete]);

  useEffect(() => {
    console.log(editorialIdToDelete);
  }, [editorialIdToDelete]);

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-certificates.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={`Redazionale`} description={""} />

        <Box
          sx={{
            mt: "25px",
          }}
        >
          <Table
            id={PagesID.certificates}
            data={dataTable?.output || []}
            columns={columns || []}
            configurationTopToolbar={actionsTopToolbar}
            configurationActionForRow={actionsRow}
            totalPages={dataTable?.metadata?.total_pages}
            modalTitle={t("hero-title")?.replace("-", "") || ""}
          />
        </Box>
      </Container>
      <ModalConfirmsCst
        open={!!editorialIdToDelete}
        title={t("delete-item", { ns: "modal" })}
        description={t("confirm-delete", { ns: "modal" })}
        routeToSamePage={true}
        onCallBackClosed={() => {
          setEditorialIdToDelete(undefined);
          setOpenToast(undefined);
        }}
        onActionConfirmed={() => handleDelete()}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default Editorial;
